import React, { useContext } from 'react';
import { IVideosContext, VideosContext } from '../../../../../videosState/videosContext';
import Text from 'components/Text/Text';
import { RequestEntity, IItemVideo, UserRoles } from 'types';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import DataController from 'components/DataController/DataController';
import { useRoleAccess } from 'hooks/useRoleAccess';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IItemVideo;
	index: number;
}

const Item: React.FC<IItem> = ({ data, index }) => {
	const { setIDForDeletion, setIDForFullInfo } = useContext<IVideosContext>(VideosContext);
	const hasDeleteAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);
	const hasEditAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);
	const isAssigned = data.restaurants.length;

	const containerClasses = classNames(style.container, {
		[style.itemAssigned]: isAssigned,
	});
	const nameRowClasses = classNames(style.row, style.name);
	const gameNameRowClasses = classNames(style.row, style.name);
	const developerRowClasses = classNames(style.row, style.studio);
	const categoryRowClasses = classNames(style.row, style.category);
	const actionRowClasses = classNames(style.row, style.action);

	const handleClickInfo = () => {
		setIDForFullInfo(data.id);
	};

	const handleSetIdForDeletion = () => {
		setIDForDeletion(data.id);
	};

	return (
		<div data-test={`Item-${index}`}>
			<div className={containerClasses}>
				<div className={nameRowClasses}>
					<div className={style.imgWrapper}>
						<ImgUploaderByEntityId
							resource={RequestEntity.Videos}
							entityID={data.iconPath ? data.id : ''}
							photoSize="Small"
							loaderSize="small"
							noImageIdIcon="videoDefaultAvatar"
						/>
					</div>
					<Text className={gameNameRowClasses} translationKey={data.name} withTooltip={true} />
				</div>
				<Text className={developerRowClasses} translationKey={data.videoStudioName} withTooltip={true} />
				<Text className={categoryRowClasses} translationKey={data.videoCategoryName} withTooltip={true} />
				<div className={actionRowClasses}>
					<DataController
						onClickInfo={handleClickInfo}
						onClickDelete={hasDeleteAccess ? handleSetIdForDeletion : undefined}
						URLWithIDToEdit={hasEditAccess ? `/entertainment/videos/edit?videoID=${data.id}` : undefined}
						size="smallBtn"
						isOpenInfo={false}
					/>
				</div>
			</div>
		</div>
	);
};

export default Item;
